<template>
   <div class="home">
      <div class="inputBox">
         <div class="help" @click="show = true">
            <img class="help_icon" src="../assets/images/help_icon.png">
            <span class="help_tips">如何查看防伪码</span>
         </div>
         <van-cell-group>
            <van-field
            ref="input"
            v-model="formData.securityCode"
            required
            clearable
            label="防伪码"
            placeholder="必填"
            @focus="inputFocus('securityCode')"
            :error-message="checkInfo.securityCode">
               <button class="scanBtn" slot="button" @click="scanQRCode">
                  <img class="scan_icon" src="../assets/images/scan_icon.png" alt="">
               </button>
            </van-field>
         </van-cell-group>
         <van-cell-group style="display: block;border-top: 1px solid rgba(237, 237, 237, .6);">
            <van-field
            ref="input"
            v-model="formData.customerName"
            required
            clearable
            label="客户姓名"
            placeholder="必填"
            @focus="inputFocus('customerName')"
            :error-message="checkInfo.customerName" />
         </van-cell-group>
         <van-cell-group style="display: block;border-top: 1px solid rgba(237, 237, 237, .6);">
            <van-field
            ref="input"
            v-model="formData.phoneNum"
            required
            clearable
            type="number"
            maxlength="11"
            label="手机号码"
            placeholder="必填"
            @focus="inputFocus('phoneNum')"
            :error-message="checkInfo.phoneNum" />
         </van-cell-group>
         <van-cell-group style="display: block;border-top: 1px solid rgba(237, 237, 237, .6);">
            <van-field
            ref="input"
            v-model="formData.code"
            required
            clearable
            label="验证码"
            placeholder="请输入验证码"
            @focus="inputFocus('code')"
            :error-message="checkInfo.code">
               <button class="code" slot="button" @click="getCode">{{ code }}</button>
            </van-field>
         </van-cell-group>
      </div>
      <div class="queryBtn">
         <button class="btn" @click="queryBtn">查询</button>
      </div>
      <van-overlay :show="show" @click="show = false">
         <div class="wrapper">
            <div class="block" @click.stop>
               <img class="img" src="../assets/images/help_img.png">
            </div>
         </div>
      </van-overlay>
      <van-overlay :show="loading">
         <div class="wrapper">
            <div class="block">
               <van-loading size="24px" color="#FFF" vertical>
                  <span style="color:#FFF">加载中...</span>
               </van-loading>
            </div>
         </div>
      </van-overlay>
      <remote-js src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"></remote-js>
   </div>
</template>

<script>
   let jsSHA = require("jssha");

   export default {
      components: {
         "remote-js": {
            render(createElement) {
               return createElement("script", {
                  attrs: { type: "text/javascript", src: this.src }
               });
            },
            props: {
               src: { type: String, required: true }
            }
         }
      },
      data() {
         return {
            show: false,
            loading: false,
            code: "",
            formData: {
               securityCode: "",
               customerName: "",
               phoneNum: "",
               code: ""
            },
            checkInfo: {
               securityCode: "",
               customerName: "",
               phoneNum: "",
               code: ""
            }
         }
      },
      mounted() {
         this.getCode();
      },
      methods: {
         // 调取微信扫一扫
         scanQRCode() {
            // wx.config({
            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            // appId: 'wx2764a69fd732b2c2', // 必填，公众号的唯一标识
            // timestamp: , // 必填，生成签名的时间戳
            // nonceStr: '', // 必填，生成签名的随机串
            // signature: '',// 必填，签名
            // jsApiList: [] // 必填，需要使用的JS接口列表
            // });

            wx.scanQRCode({
               needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
               scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
               success: function (res) {
                  var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
               }
            });
         },
         // 随机生成验证码
         getCode() {
            const random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R', 'S','T','U','V','W','X','Y','Z');
            let code = '';

            for(var i = 0; i < 4; i++){
               var index = Math.floor(Math.random()*36);
               code += random[index];
            }

            this.code = code;
         },
         inputFocus(name) {
            this.checkInfo[name] = "";
         },
         // 查询
         queryBtn() {
            let data = this.formData;

            if(data.securityCode == "") {
               this.checkInfo.securityCode = "请输入防伪码";
               return;
            }

            if(data.customerName == "") {
               this.checkInfo.customerName = "请输入客户姓名";
               return;
            }

            if(data.phoneNum == "") {
               this.checkInfo.phoneNum = "请输入手机号码";
               return;
            } else if(!/^1[3456789]\d{9}$/.test(data.phoneNum)) {
               this.checkInfo.phoneNum = "手机号码格式错误";
               return;
            }

            if(data.code == "") {
               this.checkInfo.code = "请输入验证码";
               return;
            } else if(data.code.toUpperCase() != this.code.toUpperCase()) {
               this.checkInfo.code = "验证码错误";
               this.getCode();
               return;
            }

            this.loading = true;

            this.timer = setInterval(() => {
               this.loading = false;
               this.$router.push({path: '/queryResults', query: {id: 123456}});
               clearInterval(this.timer);
            }, 1000)
         }
      }
   };
</script>

<style lang="less" scoped>
   .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .block {
         width: 252px;
         height: 108px;
         .img {
            width: 100%
         }
      }
   }
   .home {
      padding-top: 193px;
      background-image: url("../assets/images/bg_img.png");
      background-repeat: no-repeat;
      background-size: 100%;
      .inputBox {
         margin: 0 12px;
         background-color: #FFF;
         padding: 16px 16px 4px;
         border-radius: 12px;
         .help {
            height: 17px;
            display: -webkit-flex;
            display: -webkit-box;
            display: flex;
            -webkit-align-items: center;
            align-items: center;
            -webkit-justify-content: flex-end;
            justify-content: flex-end;
            .help_icon {
               width: 15px;
               height: 15px;
            }
            .help_tips {
               // line-height: 14px;
               font-size: 14px;
               margin-left: 3px;
               color: #CF3139;
            }
         }
         .van-cell-group {
            &::after {
               border: none;
            }
            .van-cell {
               height: 63px;
               padding: 20px 0 0 10px;
               &::before {
                  left: 0;
                  font-weight: bold;
               }
               .scanBtn {
                  width: 18px;
                  height: 18px;
                  display: inline-block;
                  border: none;
                  background-color: #FFF;
                  margin-right: 4px;
                  .scan_icon {
                     width: 100%;
                     height: 100%;
                  }
               }
               .code {
                  width: 60px;
                  line-height: 20px;
                  font-size: 16px;
                  border: none;
                  background-color: #FFF;
                  background-color: #CF3139;
                  color: #FFF;
                  padding: 2px 0;
               }
            }
         }
      }
      .queryBtn {
         margin: 20px 16px 0;
         .btn {
            width: 100%;
            height: 45px;
            line-height: 45px;
            border-radius: 45px;
            border: none;
            background-color: #CF3139;
            color: #FFF;
            font-size: 19px;
            text-align: center;
         }
      }
   }
</style>